exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable-canvas_vertical-scrollbar_lbD_c, .scrollable-canvas_horizontal-scrollbar_2w6OD {\n    position: absolute;\n    background: rgba(190, 190, 190, 0.8);\n    border-radius: calc(8px / 2);\n    cursor: pointer;\n}\n.scrollable-canvas_vertical-scrollbar-wrapper_2uh7v {\n    position: absolute;\n    width: 8px;\n    right: 0;\n    top: 1px;\n    height: calc(100% - 8px - 1px);\n}\n.scrollable-canvas_horizontal-scrollbar-wrapper_2bYwc {\n    position: absolute;\n    height: 8px;\n    left: 1px;\n    bottom: 0;\n    width: calc(100% - 8px - 1px);\n}\n.scrollable-canvas_vertical-scrollbar_lbD_c {\n    width: 8px;\n}\n.scrollable-canvas_horizontal-scrollbar_2w6OD {\n    height: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"vertical-scrollbar": "scrollable-canvas_vertical-scrollbar_lbD_c",
	"verticalScrollbar": "scrollable-canvas_vertical-scrollbar_lbD_c",
	"horizontal-scrollbar": "scrollable-canvas_horizontal-scrollbar_2w6OD",
	"horizontalScrollbar": "scrollable-canvas_horizontal-scrollbar_2w6OD",
	"vertical-scrollbar-wrapper": "scrollable-canvas_vertical-scrollbar-wrapper_2uh7v",
	"verticalScrollbarWrapper": "scrollable-canvas_vertical-scrollbar-wrapper_2uh7v",
	"horizontal-scrollbar-wrapper": "scrollable-canvas_horizontal-scrollbar-wrapper_2bYwc",
	"horizontalScrollbarWrapper": "scrollable-canvas_horizontal-scrollbar-wrapper_2bYwc"
};